// extracted by mini-css-extract-plugin
export default {"moreResults":"More_moreResults__T6ily","moreLabel":"More_moreLabel__x9gIB"};